import React from 'react'

export interface IConnectionContext {
  updateConnectionStatus: (connectionName: string, isConnected: boolean) => void
  connectionStatus: Record<string, boolean>
}

const Ctx = React.createContext<IConnectionContext>({
  updateConnectionStatus: () => null,
  connectionStatus: {}
})

export default Ctx
